import { SeasonLink as Link } from "../../components/Seasons/SeasonLink";
import styles from './errorPage.module.css';

export function ErrorPage({
  code = '404',
  title = 'Страница не найдена',
  description = 'Возможно, ссылка устарела или страница была перемещена.',
  primaryHref = '/profile',
  primaryLabel = 'В личный кабинет',
  secondaryHref = '/',
  secondaryLabel = 'На главную',
  inApp = false,
}) {
  return (
    <section className={`${styles.page} ${inApp ? styles.inApp : ''}`}>
      <div className={styles.code}>{code}</div>
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.description}>{description}</p>
      <div className={styles.actions}>
        <Link className={styles.primaryBtn} to={primaryHref}>{primaryLabel}</Link>
        <Link className={styles.secondaryBtn} to={secondaryHref}>{secondaryLabel}</Link>
      </div>
    </section>
  );
}
